import { createContext, useContext } from "react";

export const AuthContext = createContext({
  user: null,
  setUser: () => {},
  isTelegram: false,
});

export function useAuth() {
  return useContext(AuthContext);
}
